import React from 'react'
import ComedyContentPageCard from './comedyContentPageCard'
import ComedyMobCard from './comedyMobCard'


const ComedyContentMore = ({data,contentId,mobile}) => {
      
  return (

     <>
    
       {data.map((item,index) => { 
      
         if (item.content_id !== contentId) { 
           return  <div key={index}  className={`col-md-3 col-12 ${!mobile ? 'vcp-card-container' : ''}`} >
               { mobile ? <ComedyMobCard item={item}  index={index} /> : <ComedyContentPageCard item={item} index={index} />}
              </div>
         }

       }
       
       )}

     </>
  )
}

export default ComedyContentMore;
